/** @format */

export const DEFAULT_TEST_ID = 'tray';

export const TRANSITION_NAME = 'tray-transition';

export const CLOSE_BUTTON_CURVE_OFFSET = 'var(--layout-spacing-16)';
